var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMail = function SvgMail(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M34 15.561V27a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V15.561l10.973 3.92.347.116a9 9 0 0 0 5.707-.116L34 15.56zM32 11a2 2 0 0 1 2 2v.437l-11.646 4.16-.306.102a7 7 0 0 1-4.402-.102L6 13.437V13a2 2 0 0 1 2-2h24z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMail);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj48cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zNCAxNS41NjFWMjdhMiAyIDAgMCAxLTIgMkg4YTIgMiAwIDAgMS0yLTJWMTUuNTYxbDEwLjk3MyAzLjkyLjM0Ny4xMTZhOSA5IDAgMCAwIDUuNzA3LS4xMTZMMzQgMTUuNTZ6TTMyIDExYTIgMiAwIDAgMSAyIDJ2LjQzN2wtMTEuNjQ2IDQuMTYtLjMwNi4xMDJhNyA3IDAgMCAxLTQuNDAyLS4xMDJMNiAxMy40MzdWMTNhMiAyIDAgMCAxIDItMmgyNHoiLz48L3N2Zz4K";